var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"input",staticClass:"content-editable",class:{
        'with-backdrop': _vm.withBackdrop,
        'is-empty': _vm.isEmpty
    },attrs:{"placeholder":_vm.placeholder,"contenteditable":!_vm.readonly,"spellcheck":false},on:{"input":_vm.change,"focus":_vm.focus,"blur":_vm.blur,"paste":_vm.paste}})
}
var staticRenderFns = []

export { render, staticRenderFns }